const validate = values => {
  const errors = {}

  // Client name
  if (!values?.clientName) {
    errors.clientName = "The name is required!"
  }

  // Client site URL
  if (
    values?.clientSiteURL &&
    !/(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/i.test(
      values.clientSiteURL
    )
  ) {
    errors.clientSiteURL = "Invalid Link"
  }

  // Client Email
  if (!values?.clientContactEmail) {
    errors.clientContactEmail = "The email is required!"
  } else if (
    !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(
      values?.clientContactEmail
    )
  ) {
    errors.clientContactEmail = "Invalid email"
  }

  // Contact First name
  if (!values?.contactFirstName) {
    errors.contactFirstName = "The contact first name is required!"
  }

  // Contact Last name
  if (!values?.contactLastName) {
    errors.contactLastName = "The contact last name is required!"
  }

  // Client Success Manager Email
  if (
    (values?.clientSuccessManagerName || values?.clientSuccessManagerPhone) &&
    !values?.clientSuccessManagerEmail
  ) {
    errors.clientSuccessManagerEmail = "The email is required!"
  } else if (
    values?.clientSuccessManagerEmail &&
    !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(
      values?.clientSuccessManagerEmail
    )
  ) {
    errors.clientSuccessManagerEmail = "Invalid email"
  }

  return errors
}

export default validate
